(function () {
  var CLAIM_PREFIX = 'pbd-claimed-';
  var END_PREFIX = 'pbd-cd-end-';
  var CLAIM_WINDOW = 24 * 60 * 60;
  var COPIED_MS = 1500;

  function claimKey(code) {
    return CLAIM_PREFIX + String(code || 'FALL').toUpperCase();
  }

  function countdownEndKey(code) {
    return END_PREFIX + String(code || 'FALL').toUpperCase();
  }

  function readCountdownEnd(code) {
    try {
      return parseInt(localStorage.getItem(countdownEndKey(code)), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function writeCountdownEnd(code, endSec) {
    try {
      if (window.localStorage) localStorage.setItem(countdownEndKey(code), String(endSec));
    } catch (e) {}
    return endSec;
  }

  function discountCode(root) {
    var btn = root && root.querySelector('[data-pbd-discount]');
    return (btn && btn.getAttribute('data-pbd-discount')) || 'FALL';
  }

  function copyCode(value) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value);
        return;
      }
    } catch (e) {}
    try {
      var ta = document.createElement('textarea');
      ta.value = value;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:absolute;left:-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (err) {}
  }

  function silentApply(code) {
    var url = '/discount/' + encodeURIComponent(code);
    var usedIframe = false;
    function viaIframe() {
      if (usedIframe) return;
      usedIframe = true;
      var iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.title = '';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;overflow:hidden;';
      document.body.appendChild(iframe);
      setTimeout(function () {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 8000);
    }
    try {
      fetch(url, { credentials: 'same-origin', redirect: 'manual', cache: 'no-store' }).catch(viaIframe);
    } catch (e) {
      viaIframe();
    }
  }

  function wasClaimed(code) {
    try {
      return window.localStorage && localStorage.getItem(claimKey(code)) === '1';
    } catch (e) {
      return false;
    }
  }

  function markClaimed(code) {
    try {
      if (window.localStorage) localStorage.setItem(claimKey(code), '1');
    } catch (e) {}
  }

  function pad2(n) {
    n = Math.max(0, n | 0);
    return n < 10 ? '0' + n : String(n);
  }

  function renderPair(group, num) {
    if (!group) return;
    if (group.classList.contains('is-wide') || group.querySelectorAll('.pbd-countdown__cell').length !== 2) {
      group.classList.remove('is-wide');
      group.innerHTML = '<span class="pbd-countdown__cell"></span><span class="pbd-countdown__cell"></span>';
    }
    var str = pad2(Math.max(0, num | 0));
    if (str.length > 2) str = str.slice(-2);
    var cells = group.querySelectorAll('.pbd-countdown__cell');
    if (cells[0]) cells[0].textContent = str.charAt(0);
    if (cells[1]) cells[1].textContent = str.charAt(1);
  }

  function tickCountdown(root) {
    var timer = root.querySelector('[data-pbd-countdown]');
    if (!timer) return;
    var endSec = parseInt(timer.getAttribute('data-end'), 10) || 0;
    var hoursEl = timer.querySelector('[data-pbd-cd-h]');
    var minsEl = timer.querySelector('[data-pbd-cd-m]');
    var secsEl = timer.querySelector('[data-pbd-cd-s]');
    var left = endSec - Math.floor(Date.now() / 1000);
    if (left < 0) left = 0;
    var h = Math.floor(left / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = left % 60;
    renderPair(hoursEl, h);
    renderPair(minsEl, m);
    renderPair(secsEl, s);
    timer.setAttribute('aria-label', h + ' hours ' + pad2(m) + ' minutes ' + pad2(s) + ' seconds remaining');
  }

  function openCountdown(root, restartExpired) {
    var timer = root.querySelector('[data-pbd-countdown]');
    if (!timer) return;
    var code = discountCode(root);
    var now = Math.floor(Date.now() / 1000);
    var endSec = readCountdownEnd(code);
    if (!endSec || (restartExpired && endSec <= now)) {
      endSec = writeCountdownEnd(code, now + CLAIM_WINDOW);
    }
    timer.setAttribute('data-end', String(endSec));
    timer.hidden = false;
    timer.classList.add('is-open');
    tickCountdown(root);
    if (!root._pbdCdTimer) {
      root._pbdCdTimer = setInterval(function () {
        tickCountdown(root);
      }, 1000);
    }
  }

  function setClaimedLook(btn) {
    if (!btn) return;
    btn.classList.add('is-claimed');
    btn.classList.remove('is-copied');
    var idle = btn.querySelector('.pbd-coupon__apply-idle');
    if (idle) idle.textContent = 'Apply Discount';
  }

  function flashCopied(btn) {
    if (!btn) return;
    var idle = btn.querySelector('.pbd-coupon__apply-idle');
    btn.classList.add('is-copied');
    btn.classList.remove('is-claimed');
    if (idle) idle.textContent = 'Copied!';
    if (btn._pbdCopiedTimer) clearTimeout(btn._pbdCopiedTimer);
    btn._pbdCopiedTimer = setTimeout(function () {
      btn._pbdCopiedTimer = null;
      setClaimedLook(btn);
    }, COPIED_MS);
  }

  function claimDiscount(root, btn) {
    var value = ((btn && btn.getAttribute('data-pbd-discount')) || 'FALL').toUpperCase();
    copyCode(value);
    silentApply(value);
    markClaimed(value);
    openCountdown(root, true);
    if (btn) flashCopied(btn);
  }

  function initDiscount(root) {
    if (!root || root.dataset.pbdDiscountInit === 'true') return;
    root.dataset.pbdDiscountInit = 'true';
    var btn = root.querySelector('[data-pbd-discount]');
    var code = (btn && btn.getAttribute('data-pbd-discount')) || 'FALL';
    root.addEventListener('click', function (e) {
      var hit = e.target.closest('[data-pbd-discount]');
      if (!hit) return;
      e.preventDefault();
      claimDiscount(root, hit);
    });
    if (wasClaimed(code)) {
      setClaimedLook(btn);
      openCountdown(root);
    }
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isPc() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function findTarget(id) {
    if (!id) return null;
    return document.getElementById(id) || document.querySelector('[data-pbd-anchor="' + id + '"]');
  }

  function initAnchorNav(root) {
    if (!root || root.dataset.pbdNavInit === 'true') return;
    root.dataset.pbdNavInit = 'true';

    var links = Array.prototype.slice.call(root.querySelectorAll('[data-pbd-nav-link]'));
    var bar = root.querySelector('.pbd-anchor-nav__bar');
    var placeholder = root.querySelector('[data-pbd-nav-placeholder]');
    var scroller = root.querySelector('.pbd-anchor-nav__scroller');
    var prev = root.querySelector('[data-pbd-nav-prev]');
    var next = root.querySelector('[data-pbd-nav-next]');

    function navHeight() {
      return bar ? bar.offsetHeight : 0;
    }

    function syncPlaceholder() {
      if (!placeholder || !bar) return;
      if (root.classList.contains('is-stuck')) {
        placeholder.style.height = bar.offsetHeight + 'px';
      } else {
        placeholder.style.height = '0px';
      }
    }

    function updateStuck() {
      if (!bar || !placeholder) return;
      if (!root.classList.contains('is-stuck')) {
        if (root.getBoundingClientRect().top <= 0) {
          root.classList.add('is-stuck');
          syncPlaceholder();
        }
      } else if (placeholder.getBoundingClientRect().top > 0) {
        root.classList.remove('is-stuck');
        syncPlaceholder();
      }
    }

    function setActive(target) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-pbd-nav-link') === target);
      });
    }

    function scrollToTarget(el) {
      var top = el.getBoundingClientRect().top + window.scrollY - navHeight();
      window.scrollTo({
        top: Math.max(0, top),
        behavior: reducedMotion() ? 'auto' : 'smooth'
      });
    }

    function scrollList(dir) {
      var el = scroller || root.querySelector('.pbd-anchor-nav__list');
      if (!el) return;
      el.scrollBy({
        left: dir * Math.max(120, el.clientWidth * 0.55),
        behavior: reducedMotion() ? 'auto' : 'smooth'
      });
    }

    if (prev) {
      prev.addEventListener('click', function () { scrollList(-1); });
    }
    if (next) {
      next.addEventListener('click', function () { scrollList(1); });
    }

    function updateActive() {
      if (!links.length) return;
      var offset = navHeight() + 8;
      var current = links[0].getAttribute('data-pbd-nav-link');
      links.forEach(function (link) {
        var el = findTarget(link.getAttribute('data-pbd-nav-link'));
        if (!el) return;
        if (el.getBoundingClientRect().top <= offset) {
          current = link.getAttribute('data-pbd-nav-link');
        }
      });
      if (current) setActive(current);
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('data-pbd-nav-link');
        var el = findTarget(id);
        if (!el) return;
        e.preventDefault();
        scrollToTarget(el);
        setActive(id);
      });
    });

    window.addEventListener('scroll', function () {
      updateStuck();
      updateActive();
      updateBackToTop();
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateStuck();
      updateActive();
      updateBackToTop();
    });

    if ('IntersectionObserver' in window) {
      var stickObs = new IntersectionObserver(function () {
        updateStuck();
        updateActive();
        updateBackToTop();
      }, { threshold: [0, 0.01, 1] });
      stickObs.observe(root);
    }

    updateStuck();
    updateActive();
    updateBackToTop();
  }

  function sideStackMetrics() {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    if (mobile) return { size: 48, right: 16, gap: 10, chatBottom: 16 };
    return { size: 56, right: 24, gap: 12, chatBottom: 24 };
  }

  function pinStyle(el, prop, value) {
    if (!el) return;
    if (el.style.getPropertyValue(prop) === value && el.style.getPropertyPriority(prop) === 'important') return;
    el.style.setProperty(prop, value, 'important');
  }

  function applySideStack() {
    if (!document.getElementById('pbd-back-to-top')) return;
    var m = sideStackMetrics();
    var giftBottom = m.chatBottom + (m.size + m.gap) * 2;
    var gift = document.getElementById('crazyrocket-launch-icon');
    if (gift) {
      pinStyle(gift, 'width', m.size + 'px');
      pinStyle(gift, 'height', m.size + 'px');
      pinStyle(gift, 'right', m.right + 'px');
      pinStyle(gift, 'bottom', giftBottom + 'px');
      pinStyle(gift, 'left', 'auto');
      pinStyle(gift, 'top', 'auto');
      pinStyle(gift, 'margin', '0');
      pinStyle(gift, 'border-radius', '50%');
      pinStyle(gift, 'align-items', 'center');
      pinStyle(gift, 'justify-content', 'center');
      pinStyle(gift, 'box-sizing', 'border-box');
    }
    if (window.tidioChatApi && typeof window.tidioChatApi.adjustStyles === 'function') {
      window.tidioChatApi.adjustStyles(
        '#button.chat-closed{position:fixed!important;pointer-events:auto!important;width:' + m.size + 'px!important;height:' + m.size + 'px!important;min-width:' + m.size + 'px!important;min-height:' + m.size + 'px!important;bottom:' + m.chatBottom + 'px!important;right:' + m.right + 'px!important;left:auto!important;top:auto!important;margin:0!important;}' +
        '#button.chat-closed #button-body{width:' + m.size + 'px!important;height:' + m.size + 'px!important;}' +
        '.widgetLabel{display:none!important;}'
      );
    }
  }

  function watchGiftButton() {
    var gift = document.getElementById('crazyrocket-launch-icon');
    if (!gift || gift.dataset.pbdStackWatch === 'true') return;
    gift.dataset.pbdStackWatch = 'true';
    var obs = new MutationObserver(function () {
      applySideStack();
    });
    obs.observe(gift, { attributes: true, attributeFilter: ['style'] });
  }

  function initSideStack() {
    if (window.__pbdSideStack) return;
    if (!document.getElementById('pbd-back-to-top')) return;
    window.__pbdSideStack = true;
    applySideStack();
    watchGiftButton();
    document.addEventListener('tidioChat-ready', applySideStack);
    window.addEventListener('resize', applySideStack);
    [600, 1800, 4000].forEach(function (delay) {
      window.setTimeout(function () {
        watchGiftButton();
        applySideStack();
      }, delay);
    });
  }

  function initBackToTop() {
    var buttons = document.querySelectorAll('[data-pbd-back-to-top]');
    if (!buttons.length) return;
    buttons.forEach(function (el, i) {
      if (i > 0) {
        el.remove();
        return;
      }
      if (el.dataset.pbdBttInit === 'true') return;
      el.dataset.pbdBttInit = 'true';
      el.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: reducedMotion() ? 'auto' : 'smooth'
        });
      });
    });
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    updateBackToTop();
  }

  function updateBackToTop() {
    var btn = document.querySelector('[data-pbd-back-to-top]');
    if (!btn) return;
    btn.classList.toggle('is-visible', window.scrollY > 240);
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-pbd-discount-root]').forEach(initDiscount);
    if (root.hasAttribute && root.hasAttribute('data-pbd-discount-root')) initDiscount(root);
    root.querySelectorAll('[data-pbd-anchor-nav]').forEach(initAnchorNav);
    if (root.hasAttribute && root.hasAttribute('data-pbd-anchor-nav')) initAnchorNav(root);
    initBackToTop();
    initSideStack();
    initAddToCart();
  }

  function cartSectionIds() {
    var ids = [];
    var mini = document.querySelector('xo-cart-mini');
    var cart = document.querySelector('xo-cart');
    if (mini && mini.id) ids.push(mini.id);
    if (cart && cart.id) ids.push(cart.id);
    return ids;
  }

  var WATCH_MIN_CENTS = 100000;
  var watchHandledThisOpen = false;
  var watchClosedThisOpen = false;
  var WATCH_DEBUG = true;

  function watchLog() {
    if (!WATCH_DEBUG || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[pbd-watch]');
    console.log.apply(console, args);
  }

  function watchElInfo(el) {
    if (!el || !el.tagName) {
      return el === document ? 'document' : el === window ? 'window' : String(el);
    }
    var info = el.tagName.toLowerCase();
    if (el.id) info += '#' + el.id;
    if (el.className && typeof el.className === 'string') {
      info += '.' + el.className.trim().split(/\s+/).slice(0, 4).join('.');
    }
    if (el.getAttribute && el.hasAttribute('data-pbd-watch-close')) info += '[data-pbd-watch-close]';
    return info;
  }

  function watchPathInfo(e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    var out = [];
    for (var i = 0; i < path.length && i < 12; i++) out.push(watchElInfo(path[i]));
    return out;
  }

  function allWatchPopups() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-pbd-watch-popup]'));
  }

  function watchPopupSnapshot(root) {
    if (!root) return null;
    return {
      parent: watchElInfo(root.parentNode),
      hidden: !!root.hidden,
      openClass: root.classList.contains('pbd-watch-popup--open')
    };
  }

  function activeWatchPopup() {
    var host = watchHost();
    var list = allWatchPopups();
    var i;
    if (host) {
      for (i = 0; i < list.length; i++) {
        if (host.contains(list[i]) && !list[i].hidden) return list[i];
      }
      for (i = 0; i < list.length; i++) {
        if (host.contains(list[i])) return list[i];
      }
    }
    for (i = 0; i < list.length; i++) {
      if (!list[i].hidden) return list[i];
    }
    return list[0] || null;
  }

  function watchPopupFromEvent(e) {
    var t = e && e.target;
    if (t && t.closest) {
      var fromTarget = t.closest('[data-pbd-watch-popup]');
      if (fromTarget) return fromTarget;
    }
    var path = e && e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.getAttribute && el.hasAttribute('data-pbd-watch-popup')) return el;
    }
    return activeWatchPopup();
  }

  function watchHitInfo(x, y, eventRoot) {
    var hit = document.elementFromPoint(x, y);
    var list = allWatchPopups();
    var root = eventRoot || (hit && hit.closest && hit.closest('[data-pbd-watch-popup]')) || activeWatchPopup();
    var closeBtn = root && root.querySelector('.pbd-watch-popup__close');
    var closeRect = closeBtn && closeBtn.getBoundingClientRect();
    var rootRect = root && root.getBoundingClientRect();
    var overClose = !!(closeRect &&
      x >= closeRect.left && x <= closeRect.right &&
      y >= closeRect.top && y <= closeRect.bottom);
    return {
      count: list.length,
      nodes: list.map(watchPopupSnapshot),
      elementFromPoint: watchElInfo(hit),
      hitPointerEvents: hit && hit instanceof Element ? window.getComputedStyle(hit).pointerEvents : null,
      overCloseRect: overClose,
      closeRect: closeRect ? {
        top: Math.round(closeRect.top),
        left: Math.round(closeRect.left),
        w: Math.round(closeRect.width),
        h: Math.round(closeRect.height)
      } : null,
      rootRect: rootRect ? {
        top: Math.round(rootRect.top),
        left: Math.round(rootRect.left),
        w: Math.round(rootRect.width),
        h: Math.round(rootRect.height),
        hidden: !!root.hidden,
        openClass: root.classList.contains('pbd-watch-popup--open'),
        parent: watchElInfo(root.parentNode)
      } : null
    };
  }

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return String(root).replace(/\/?$/, '/');
  }

  function jsonFetch(url, body) {
    var opts = {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    };
    if (body !== undefined) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || (data && (data.errors || (typeof data.status === 'number' && data.status >= 400)))) {
          throw data || {};
        }
        return data || {};
      });
    });
  }

  function fetchCart() {
    return fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json();
    });
  }

  function checkoutUrl() {
    return shopRoot() + 'checkout';
  }

  function setCtaBusy(el, on) {
    var wrap = (el && el.closest('.pbd-btn--solid')) || el;
    if (!wrap) return;
    var buttons = wrap.querySelectorAll('button');
    if (on) wrap.setAttribute('aria-busy', 'true');
    else wrap.removeAttribute('aria-busy');
    for (var i = 0; i < buttons.length; i++) buttons[i].disabled = !!on;
  }

  function clearAllCtaBusy() {
    var wraps = document.querySelectorAll('.pbd-btn--solid[aria-busy="true"]');
    for (var i = 0; i < wraps.length; i++) setCtaBusy(wraps[i], false);
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    setTimeout(function () {
      var trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
      if (trigger) trigger.click();
    }, 300);
  }

  function addVariantToCart(variantId) {
    var body = { id: Number(variantId), quantity: 1 };
    var ids = cartSectionIds();
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname || '/';
    }
    return jsonFetch('/cart/add.js', body);
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data || {};
        return data || {};
      });
    });
  }

  function mergeAddedCart(data) {
    if (!data || !window.xoStore || typeof window.xoStore.set !== 'function') return;
    try {
      window.xoStore.set('xo-cart', function (prev) {
        var next = Object.assign({}, prev || {});
        if (typeof data.item_count === 'number') next.size = data.item_count;
        if (data.sections && typeof data.sections === 'object') {
          next.sections = Object.assign({}, (prev && prev.sections) || {}, data.sections);
        }
        return next;
      })('pbd-atc');
    } catch (e) {}
  }

  function cartModal() {
    return document.querySelector('xo-modal[xo-name="cart"]');
  }

  function isCartOpen() {
    var modal = cartModal();
    if (!modal) return false;
    var active = modal.getAttribute('xo-active');
    return modal.hasAttribute('xo-active') && active !== 'false';
  }

  function watchHost() {
    return cartModal();
  }

  function mountWatchPopup(root) {
    var host = watchHost();
    if (!host) {
      watchLog('mount: no cart host');
      return false;
    }
    var slot = (host.getAttribute('xo-name') || 'cart') + '-inner';
    if (root.getAttribute('slot') !== slot) root.setAttribute('slot', slot);
    if (root.parentNode !== host) {
      watchLog('mount: append to', watchElInfo(host), 'slot=', slot);
      host.appendChild(root);
    }
    return true;
  }

  function placeWatchPopup(root) {
    root.style.inset = '0';
    root.style.width = '100%';
    root.style.height = '100%';
    var stage = root.querySelector('.pbd-watch-popup__stage');
    if (stage) {
      var w = root.clientWidth || 344;
      var s = Math.min(1, (w - 24) / 375);
      stage.style.transform = 'scale(' + s + ')';
    }
  }

  function hideOneWatchPopup(root) {
    if (!root) return;
    root.hidden = true;
    root.classList.remove('pbd-watch-popup--open');
    root.setAttribute('aria-hidden', 'true');
  }

  function hideWatchPopup(reason, eventRoot) {
    watchClosedThisOpen = true;
    var list = allWatchPopups();
    watchLog('hide', reason || '', {
      count: list.length,
      eventRoot: watchPopupSnapshot(eventRoot),
      nodes: list.map(watchPopupSnapshot),
      watchClosedThisOpen: watchClosedThisOpen,
      watchHandledThisOpen: watchHandledThisOpen
    });
    hideOneWatchPopup(eventRoot);
    for (var i = 0; i < list.length; i++) hideOneWatchPopup(list[i]);
  }

  function bindWatchClose(root) {
    if (!root) return;
    if (root.getAttribute('data-pbd-close-bound') === '1') {
      watchLog('bindClose: already bound');
      return;
    }
    root.setAttribute('data-pbd-close-bound', '1');
    var nodes = root.querySelectorAll('[data-pbd-watch-close]');
    watchLog('bindClose: nodes=', nodes.length, Array.prototype.map.call(nodes, watchElInfo));
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].addEventListener('pointerdown', function (e) {
        watchLog('close-node pointerdown', watchElInfo(e.currentTarget), watchElInfo(e.target));
        e.preventDefault();
        e.stopPropagation();
      }, true);
      nodes[i].addEventListener('click', function (e) {
        watchLog('close-node click → hide', watchElInfo(e.currentTarget), watchElInfo(e.target));
        e.preventDefault();
        e.stopPropagation();
        hideWatchPopup('close-node-click', watchPopupFromEvent(e));
      }, true);
    }
  }

  function showWatchPopup() {
    if (watchClosedThisOpen) {
      watchLog('show: skipped, already closed this open');
      return;
    }
    var root = activeWatchPopup();
    if (!root) {
      watchLog('show: no popup node');
      return;
    }
    allWatchPopups().forEach(bindWatchClose);
    function pin(from) {
      if (watchClosedThisOpen) {
        watchLog('pin skip', from, 'already closed');
        return;
      }
      root = activeWatchPopup() || root;
      if (!mountWatchPopup(root)) return;
      if (watchClosedThisOpen) {
        watchLog('pin skip after mount', from, 'already closed');
        hideOneWatchPopup(root);
        return;
      }
      root.hidden = false;
      root.removeAttribute('hidden');
      root.removeAttribute('aria-hidden');
      root.classList.add('pbd-watch-popup--open');
      var others = allWatchPopups();
      for (var i = 0; i < others.length; i++) {
        if (others[i] !== root) hideOneWatchPopup(others[i]);
      }
      placeWatchPopup(root);
      watchLog('pin', from, {
        parent: watchElInfo(root.parentNode),
        count: allWatchPopups().length,
        w: root.clientWidth,
        h: root.clientHeight
      });
    }
    pin('sync');
    requestAnimationFrame(function () { pin('raf'); });
    setTimeout(function () { pin('80ms'); }, 80);
    setTimeout(function () { pin('250ms'); }, 250);
  }

  function maybeWatchPopup() {
    if (watchHandledThisOpen || watchClosedThisOpen) {
      watchLog('maybe: skip', { watchHandledThisOpen: watchHandledThisOpen, watchClosedThisOpen: watchClosedThisOpen });
      return Promise.resolve();
    }
    watchHandledThisOpen = true;
    return fetchCart().then(function (cart) {
      var total = cart && Number(cart.total_price);
      watchLog('maybe: cart total', total, 'min', WATCH_MIN_CENTS);
      if (watchClosedThisOpen) return;
      if (!cart || total < WATCH_MIN_CENTS) return;
      showWatchPopup();
    }).catch(function (err) {
      watchLog('maybe: fetch fail', err);
      watchHandledThisOpen = false;
    });
  }

  function onCartOpened() {
    watchLog('cart opened');
    maybeWatchPopup();
  }

  function onCartClosed() {
    watchLog('cart closed');
    watchHandledThisOpen = false;
    hideWatchPopup('cart-closed');
    watchClosedThisOpen = false;
  }

  function initWatchPopup() {
    if (window.__pbdWatchPopupBound) return;
    window.__pbdWatchPopupBound = true;
    watchLog('init listeners');
    function logPointer(type, e) {
      var eventRoot = watchPopupFromEvent(e);
      var list = allWatchPopups();
      var popupOpen = list.some(function (node) {
        return !node.hidden && node.classList.contains('pbd-watch-popup--open');
      });
      if (!popupOpen && type !== 'click') return;
      var path = e.composedPath ? e.composedPath() : [e.target];
      var close = null;
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el && el.matches && el.matches('[data-pbd-watch-close]')) {
          close = el;
          break;
        }
      }
      if (!popupOpen && !close) return;
      watchLog(type, {
        target: watchElInfo(e.target),
        closeInPath: close ? watchElInfo(close) : null,
        xy: { x: Math.round(e.clientX), y: Math.round(e.clientY) },
        defaultPrevented: e.defaultPrevented,
        hit: watchHitInfo(e.clientX, e.clientY, eventRoot),
        path: watchPathInfo(e)
      });
      return { close: close, eventRoot: eventRoot };
    }
    document.addEventListener('pointerdown', function (e) {
      var info = logPointer('pointerdown', e);
      if (!info || !info.close) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    document.addEventListener('click', function (e) {
      var info = logPointer('click', e);
      if (!info || !info.close) return;
      watchLog('document click matched close → hide');
      e.preventDefault();
      e.stopPropagation();
      hideWatchPopup('document-click', info.eventRoot);
    }, true);
    window.addEventListener('resize', function () {
      var root = activeWatchPopup();
      if (root && !root.hidden) placeWatchPopup(root);
    });
    var lastOpen = false;
    function syncCartOpen() {
      var open = isCartOpen();
      if (open && !lastOpen) onCartOpened();
      if (!open && lastOpen) onCartClosed();
      lastOpen = open;
    }
    var obs = new MutationObserver(syncCartOpen);
    obs.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['xo-active']
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('xo-modal-trigger[xo-name="cart"]')) return;
      setTimeout(syncCartOpen, 50);
      setTimeout(syncCartOpen, 320);
    });
    setTimeout(syncCartOpen, 0);
  }

  function initAddToCart() {
    if (window.__pbdAtcBound) return;
    window.__pbdAtcBound = true;
    initWatchPopup();
    document.addEventListener('click', function (e) {
      var buy = e.target.closest('[data-pbd-buynow]');
      var atc = e.target.closest('[data-pbd-atc]');
      var btn = buy || atc;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var wrap = btn.closest('.pbd-btn--solid') || btn;
      if (btn.disabled || wrap.getAttribute('aria-busy') === 'true') return;
      var variantId = btn.getAttribute('data-variant-id');
      var fallback = btn.getAttribute('data-fallback');
      if (!variantId) {
        if (fallback) window.location.href = fallback;
        return;
      }
      setCtaBusy(btn, true);
      var task = buy
        ? clearCart().then(function () { return addVariantToCart(variantId); }).then(function () {
          window.location.href = checkoutUrl();
        })
        : addVariantToCart(variantId).then(function (data) {
          mergeAddedCart(data);
          openCartDrawer();
        });
      task.catch(function () {
        if (fallback) window.location.href = fallback;
      }).then(function () {
        if (!buy) setCtaBusy(btn, false);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });

  window.addEventListener('pageshow', function () {
    clearAllCtaBusy();
  });
})();
